import React from 'react';
import {Input, InputGroup, Loader, Slider, Toggle} from 'rsuite';
import UpdateButton from "../../../../../shared/UpdateButton/UpdateButton";
import {TfiSave} from "react-icons/tfi";
import {getVoltageStyle} from "../utils/Dimmer.utils";
import StatusControl from "../../../../../shared/StatusControl/StatusControl";

const DimmerChannelsSection = ({
                                 channels,
                                 onToggleChannel,
                                 onBrightnessChange,
                                 onDescriptionChange,
                                 onUpdateDescription,
                                 loading,
                                 deviceId,
                                 onRefreshData
                               }) => {

  return (
    <>
      <div className="row mt-3 p-2">
        {channels.length > 0 ? (
          channels.map((channel, index) => (
            <div
              className="col-xxl-6 col-lg-6 col-md-12 col-sm-12 mb-3"
              key={index}
            >
              <div className="fieldset-wrapper control bg-white mt-0 pt-0 p-1">
                <div className="legend-title d-flex text-center align-items-center" style={{height: 20}}>
                  <StatusControl status={channel?.isActive ? "online" : "offline"}/>
                  <span>Канал {channel?.channel}</span>
                </div>
                <div className="clock-wrapper w-100">
                  <div className="row align-items-center mb-2" style={{width:'100%'}}>
                    <div className="col-md-6 d-flex justify-content-start">
                      <Toggle
                        size={"sm"}
                        checked={channel?.enabled}
                        loading={loading}
                        color="blue"
                        checkedChildren="ON"
                        unCheckedChildren="OFF"
                        onChange={() => onToggleChannel(index)}
                      />
                    </div>
                    <div className="col-md-6 d-flex justify-content-end">
                      <UpdateButton onRefresh={onRefreshData}/>
                    </div>
                  </div>
                </div>
                <div className="row  mb-2">
                  <div className="col-md-12 pe-4">
                    <Slider
                      loading={loading}
                      value={channel.brightness}
                      progress
                      max={255}
                      tooltip={false}
                      onChange={value => onBrightnessChange(index, value)}
                    />
                  </div>
                </div>
                <div className="row pe-2">
                  <div className="col-md-6">
                    <InputGroup>
                      <InputGroup.Addon>Напряжение</InputGroup.Addon>
                      <Input
                        style={getVoltageStyle(channel.voltage)}
                        value={channel.voltage || ''}
                        readOnly/>
                      <InputGroup.Addon>В</InputGroup.Addon>
                    </InputGroup>
                  </div>
                  <div className="col-md-6">
                    <InputGroup>
                      <InputGroup.Addon>Яркость</InputGroup.Addon>
                      <Input value={Math.round((channel.brightness / 255) * 100)} readOnly/>
                      <InputGroup.Addon>%</InputGroup.Addon>
                    </InputGroup>
                  </div>
                </div>
                <div className="row pe-2">
                  <div className="col-md-12 mt-2 mb-2">
                    <InputGroup>
                      <InputGroup.Addon>Описание</InputGroup.Addon>
                      <Input
                        value={channel.description || ''}
                        onChange={(value) => onDescriptionChange(index, value)}
                      />
                      <InputGroup.Addon style={{cursor: 'pointer'}} onClick={() => onUpdateDescription(channel.description, index)}>
                        <TfiSave/>
                      </InputGroup.Addon>
                    </InputGroup>
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="text-center">
            <Loader size="lg" />
          </div>
        )}
      </div>

    </>
  );
};

export default DimmerChannelsSection;
